export default function ProductPage() {
  return <h1>Order Page</h1>;
}